import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { Assessment } from './assessment';
import { MatButtonModule} from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    Assessment
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    RouterModule.forChild([
      {
        path: 'assessment/:stateMachineName/:guidanceSubscriptionId',
        component: Assessment
      },
      {
        path: 'assessment/:stateMachineName/:guidanceSubscriptionId/:formOID',
        component: Assessment
      }
    ])
  ],
  exports: [
    Assessment
  ],
  providers: [

  ]
})
export class AssessmentModule {}
